// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"b8229a39","425":"54ad274f","510":"1cccba8f","532":"414d80e7","633":"46e1b5e2","634":"ab7467c1","922":"f6a8acef","937":"097cd9b9","972":"1b6bf371"}[chunkId] + ".chunk.js";
};